import { AdditionalInfoType } from '../../types';

const { USER, SYSTEM } = AdditionalInfoType;

export function getOriginallyAppliedFilters(
    initialFilter?: AdditionalInfoType[],
    noSystemMessagesByDefault?: boolean
) {
    if (Array.isArray(initialFilter)) {
        return initialFilter;
    }

    if (noSystemMessagesByDefault) {
        return [USER];
    }

    return [USER, SYSTEM];
}
